<page-title [title]="title"></page-title>
<p>Consulte e gerencie suas formas de pagamento:</p>
<mat-tab-group>
    <mat-tab label="Ativas"> 
        <div class="col-xs-12 "  *ngFor="let method of methodActive">
            <mat-card (click)="openPaymentMethodDetail(method)">
              <mat-icon color="primary" *ngIf="method?.icon">{{method?.icon }}</mat-icon>  {{method.name }}
              <div *ngIf="method.flags">
                <b>Bandeiras:</b> 
                <span *ngFor="let flag of method.flags; let i = index">
                    <span *ngIf="i > 0">,</span>
                    {{ flag.name }}                   
                </span>
              </div>
            </mat-card>
        </div>
    </mat-tab>
    <mat-tab label="Inativas"> 
        <div class="col-xs-12  " *ngFor="let method of methodInactive">
           <mat-card (click)="openPaymentMethodDetail(method)">
              <mat-icon color="primary" *ngIf="method?.icon">{{ method?.icon }}</mat-icon>  {{method.name }}
              <div *ngIf="method.flags">
                <b>Bandeiras:</b> 
                <span *ngFor="let flag of method.flags; let i = index">
                    <span *ngIf="i > 0">,</span>
                    {{ flag.name }}                   
                </span>
              </div>
            </mat-card>
        </div>
    </mat-tab>
  </mat-tab-group>

